export const raiseTicketApi = (raiseTicketFormData, BeURL) => {
    if (!raiseTicketFormData || !BeURL) {
        return;
    }
    fetch(`${BeURL}/ticket-raise`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(raiseTicketFormData)
    })
        .then(res => res.json())
        .then(data => {
            if (data?.success === true) {
                alert(data.message)
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error while raising ticket:", err);
            alert("Unable to raise ticket. Please try again later.");
        })
}

export const fetchTicketsApi = (setGetTickets, BeURL, perPage, currentPage, setTotalPages, setTotalCount) => {

    fetch(`${BeURL}/fetch-tickets`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({ perPage, currentPage })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                setGetTickets(data?.ticket)
                setTotalCount(data.totalCount || 0)
                setTotalPages(data.totalPages || 0)
            }
            else {
                setGetTickets([])
            }
        })
        .catch(err => {
            console.log("Error while get tikcets:", err);
            alert("Unable to get tikcets. Please try again later.");
        })
}

export const fetchViewTicketsIdApi = (setGetTicketsViewId, ticketId, BeURL) => {
    fetch(`${BeURL}/fetch-tickets/${ticketId}`, {
        method: 'GET',
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                setGetTicketsViewId({
                    ticket: data?.ticket,
                    user: data?.user
                });

            }
            else {
                console.log(data.message)
                setGetTicketsViewId([])
            }
        })
        .catch(err => {
            console.log("Error while getting tickets:", err);
            alert("Unable to get tickets. Please try again later.");;
        })
}

export const resolveApi = (ticketId, BeURL) => {
    fetch(`${BeURL}/resolve-ticket`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ ticketId })
    })
        .then(res => res.json())
        .then(data => {
            if (data?.success === true) {
                alert(data.message)
                window.location.reload()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error while resolve ticket:", err);
            alert("Unable to resolve ticket. Please try again later.");
        })
}